import React, { Component } from "react";
import { connect } from "react-redux";
import ResizeObserver from "resize-observer-polyfill";
import Modal from "sub_components/Common/PortalModalNew";
import { bindActionCreators } from "redux";
import { PopUp } from "styled_components/Common/PopUp";
import { BloxButton } from "styled_components/Common/BloxButton";
import { RESOLUTIONS } from "services/config";
import { UserApi } from "services/user";

/** v3 imports */
import ForgotPassword from "sub_components/Login/ForgotPassword";
import HelpModal from "sub_components/Common/HelpModal";
import { LoginContainer } from "../../styled_components/Login/LoginContainer";
import {
  sampleEnterUsername,
  loginUserPhaseOne,
  loginUserPhaseTwo,
  mfaOptionRequest,
  requestLoginUsernameReset,
  loginReset,
  enterMfaTimeout1,
  enterMfaTimeout1Email,
  enterMfaTimeout1Phone,
  enterMfaTimeout2,
  resetMfaTimeoutCondition,
} from "./../../actions";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const dcbloxLogo = `${CDN_URL}common/dcblox-logo-lg.svg`;

const edge = `${CDN_URL}common/edge.png`;
const chrome = `${CDN_URL}common/chrome.png`;
const safari = `${CDN_URL}common/safari.png`;
const firefox = `${CDN_URL}common/firefox.png`;
const states = {
  USERNAME: "USERNAME",
  PASSWORD: "PASSWORD",
  MFA: "MFA",
};
const MFA_OPTIONS = {
  EMAIL: "EMAIL",
  PHONE: "PHONE",
};
/**
 * Container component for LoginInput and Canvas Components
 * Handles login progress once authenticated
 */

function getModalTitle(browserName) {
  return browserName === "Unsupported browser detection"
    ? "Your browser is important....."
    : "Browsers are like old cars....";
}

function getModalText(browserName) {
  return browserName === "Unsupported browser detection"
    ? "custom"
    : "every few years you need to upgrade. This site may not work with your browser.";
}

function checkCorrectOperaVersion(version) {
  let correctVersion = false;
  if (parseInt(version) > 80) {
    correctVersion = true;
  }
  return correctVersion;
}

function browserDetect(setShowModal, setModalTitle, setModalText) {
  const userAgent = navigator.userAgent;
  let browserName = "Unsupported browser detection";
  let version;
  let correctVersion = false;

  if (userAgent.match(/opr\//i)) {
    browserName = "opera";
    version = userAgent.split("OPR/")[1];
    version = version.substring(0, 3);

    correctVersion = checkCorrectOperaVersion(version);
  } else if (userAgent.match(/edg/i)) {
    browserName = "edge";
    version = userAgent.split("Edg/")[1];
    version = version.substring(0, 3);
    if (parseInt(version) > 90) {
      correctVersion = true;
    }
  } else if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "chrome";
    version = userAgent.split("Chrome/")[1];
    version = version.substring(0, 3);
    if (parseInt(version) > 90) {
      correctVersion = true;
    }
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "firefox";
    version = userAgent.split("Firefox/")[1];
    version = version.substring(0, 3);

    if (parseInt(version) > 90) {
      correctVersion = true;
    }
  } else if (userAgent.match(/safari/i)) {
    browserName = "safari";
    version = userAgent.split("Version/")[1];
    version = version.substring(0, 3);
    if (parseInt(version) > 14) {
      correctVersion = true;
    }
  }
  const modalTitle = getModalTitle(browserName);

  const modalText = getModalText(browserName);

  if (!correctVersion) {
    setModalTitle(modalTitle);
    setModalText(modalText);
    setShowModal(true);
  }
}

class LoginPageNew extends Component {
  constructor(props) {
    super(props);

    this.timer = null;
    this.state = {
      rowHeight: 0,
      margin: [],
      alert: null,
      containerPadding: [],
      layout: [],
      showModal: false,
      showHelpModal: false,
      modalTitle: "",
      modalText: "",
      showBrowserModal: false,
      breakpoint: RESOLUTIONS.MED,
      enabled: true,
      forceShow: false,
      enabled: true,
      mfaRequestType: "SUBMIT CODE",
      mfaOption: MFA_OPTIONS.EMAIL,
      email: "",
    };
  }

  getCustomBody = () => {
    const { modalText } = this.state;
    let newText = "";
    if (modalText === "custom") {
      newText =
        "<div className='text body10'>" +
        "you can use it to download " +
        "<img src=" +
        chrome +
        " /> ," +
        "<img src=" +
        firefox +
        " /> ," +
        "<img src=" +
        safari +
        " />, <img src=" +
        edge +
        " />.This site may not work with your browser.</div>";
    }
    return newText;
  };

  /**
   * Checks to see if the user is authenticated. If so, move to
   * the next page (HomePage). Waits for 2 seconds before re-routing
   * to allow animation to finish.
   */
  checkCompletion = () => {
    const { auth_status, navigateToPortal } = this.props;
    if (
      auth_status.type === "LOGIN_SUCCESS_PHASE_ONE_NO_MFA" ||
      (auth_status.context === "AUTHENTICATED" && auth_status.isAuthenticated)
    ) {
      this.timer = setTimeout(() => {
        navigateToPortal();
      }, 500);
    }
  };

  componentWillUnmount() {
    clearTimeout(this.timer);
  }
  onBreakpointChange = (breakpoint) => {
    let rowHeight = 0;
    let margin;
    let containerPadding;

    switch (breakpoint) {
      case "xs":
        rowHeight = 15;
        margin = [21, 0];
        containerPadding = [90, 0];
        break;
      case "sm":
        rowHeight = 18;
        margin = [21, 0];
        containerPadding = [95, 0];
        break;
      case "md":
        rowHeight = 21;
        margin = [22, 0];
        containerPadding = [120, 0];
        break;
      case "lg":
        rowHeight = 24;
        margin = [32, 0];
        containerPadding = [160, 0];
        break;
      default:
        rowHeight = 23;
        margin = [22, 0];
        containerPadding = [30, 0];
        break;
    }

    this.setState({ rowHeight, margin, containerPadding });
  };
  setShowModal = () => {
    const { showBrowserModal } = this.state;
    this.setState({ showBrowserModal: !showBrowserModal });
  };
  setModalText = (text) => {
    this.setState({ modalText: text });
  };
  setModalTitle = (title) => {
    this.setState({ modalTitle: title });
  };

  checkForAlert = () => {
    UserApi.getAlert()
      .then((response) => {
        if (response && !response.data.error) {
          const alerts = response?.data?.alerts;
          if (alerts && alerts.length !== 0) {
            this.setState({ alert: alerts[0] });
          }
        }
      })
      .catch(() => {});
  };
  componentDidMount() {
    this.onBreakpointChange();
    this.checkForAlert();
    browserDetect(this.setShowModal, this.setModalTitle, this.setModalText);

    this.screenObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const screenWidth = entry.contentRect.width;
        const screenHeight = entry.contentRect.height;
        this.updateScreenBreakpoint(screenWidth, screenHeight);
      });
    });
    const htmlEl = document.querySelector("html");
    this.screenObserver.observe(htmlEl);
  }
  componentDidUpdate(prevProps) {
    const { auth_status } = this.props;
    const { context } = auth_status;

    if (prevProps?.auth_status?.context !== context) {
      this.checkCompletion();
    }
  }
  showModal = () => {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });
  };

  showHelpModal = () => {
    const { showHelpModal } = this.state;
    this.setState({ showHelpModal: !showHelpModal });
  };

  setMFATimeout = (enterMfaTimeout2) => {
    this.setState({ enabled: false });
    clearInterval(this.mfaResponseTimeout);
    this.mfaResponseTimeout = setInterval(() => {
      if (!this.firstResponseWait) {
        this.firstResponseWait = Date.now();
        this.setState({ reminder: "question" });

        this.changeMessageInterval = setInterval(() => {
          this.changeMessage();
        }, 4000);
      } else {
        clearInterval(this.changeMessageInterval);
        const input = document.querySelector("input");
        if (input) {
          input.classList.add("no-blinking");
        }

        enterMfaTimeout2();
        this.setState({
          reminder: "exclamation",
          subMessage: "Please send a new request.",
          forceShow: true,
          mfaRequestType: "RESEND CODE",
        });
        clearInterval(this.mfaResponseTimeout);
      }
    }, 30000);
  };

  resetMfaOptions = () => {
    const { enterMfaTimeout2 } = this.props;
    enterMfaTimeout2();
    this.setState({
      reminder: null,
      subMessage: "Please send a new request.",
      forceShow: true,
      mfaRequestType: "RESEND CODE",
    });
  };

  updateScreenBreakpoint = (screenWidth, screenHeight) => {
    let breakpoint = RESOLUTIONS.MED;

    if (screenWidth > RESOLUTIONS.LOW && screenWidth <= RESOLUTIONS.MED) {
      breakpoint = RESOLUTIONS.LOW;
    } else if (
      screenWidth > RESOLUTIONS.MED &&
      screenWidth <= RESOLUTIONS.HIGH
    ) {
      breakpoint = RESOLUTIONS.MED;
    } else if (screenWidth > RESOLUTIONS.HIGH) {
      breakpoint = RESOLUTIONS.HIGH;
    } else {
      breakpoint = RESOLUTIONS.MIN;
    }
    this.setState({ breakpoint, screenWidth, screenHeight });
  };

  receiveInput = (email, password) => {
    const { auth_status, loginUserPhaseOne, loginUserPhaseTwo } = this.props;
    const { code, mfaOption, email: currentUsersEmail } = this.state;
    const { context } = auth_status;
    const inputEmpty =
      email && email.length !== 0 && password && password.length !== 0
        ? false
        : true;

    if (context === states.USERNAME && !inputEmpty) {
      console.log("login input");
      const credentials = {
        username: email.toLowerCase(),
        password,
      };
      this.setState({ email });
      loginUserPhaseOne(credentials);
    } else if (!inputEmpty) {
      console.log("login input 2");
      if (email && password) {
        console.log("login input 3");
        loginUserPhaseTwo(password, mfaOption, currentUsersEmail.toLowerCase());
      } else {
        console.log("login input 4");
        loginUserPhaseTwo(code, mfaOption, currentUsersEmail.toLowerCase());
      }
    } else if (inputEmpty && context === states.MFA) {
      console.log("login input 5");
      loginUserPhaseTwo(code, mfaOption, currentUsersEmail.toLowerCase());
    }
  };
  updateMFAoption = (value) => {
    this.setState({ mfaOption: value, mfaRequestType: "SUBMIT CODE" });
  };
  setMFACode = (e) => {
    this.setState({ code: e.target.value });
  };

  resetLogin = () => {
    const { auth_status, requestLoginUsernameReset } = this.props;
    const { attemptCount, message, failedUserName } = auth_status;
    const resetMessage = "HELLO, PLEASE ENTER YOUR EMAIL & PASSWORD.";

    requestLoginUsernameReset(failedUserName, attemptCount, message);

    setTimeout(() => {
      requestLoginUsernameReset(failedUserName, attemptCount, resetMessage);
    }, 2000);
    this.setState({
      forceShow: true,
      mfaRequestType: "RESEND CODE",
    });
  };

  render() {
    const {
      showModal,
      showHelpModal,
      showBrowserModal,
      mfaRequestType,
      modalTitle,
      modalText,
      breakpoint,
      enabled,
      forceShow,
      code,
      alert,
    } = this.state;

    const { auth_status, mfaOptionRequest } = this.props;

    return (
      <div className="login login-section">
        <div className="logo">
          <img src={dcbloxLogo} />
        </div>
        <LoginContainer
          receiveInput={this.receiveInput}
          auth_status={auth_status}
          enabled={enabled}
          forceShow={forceShow}
          updateMFAoption={this.updateMFAoption}
          mfaOptionRequest={mfaOptionRequest}
          setMFACode={this.setMFACode}
          code={code}
          resetLogin={this.resetLogin}
          resetMfaOptions={this.resetMfaOptions}
          mfaRequestType={mfaRequestType}
        />
        {showBrowserModal && (
          <Modal>
            <PopUp
              showModal={showBrowserModal}
              customBody={this.getCustomBody()}
              closeModal={() => this.setShowModal(false)}
              footer={
                <BloxButton
                  className="buttons41"
                  id="okay"
                  text="OKAY"
                  module="support"
                  enabled={true}
                  onClick={() => this.setShowModal(false)}
                  cypressId="okay"
                />
              }
              title={modalTitle}
              text={modalText}
              module="support"
            />
          </Modal>
        )}
        <div data-cy="help-modal" className="help-modal">
          <HelpModal
            isOpen={showHelpModal}
            toggleOpen={this.showHelpModal}
            breakpoint={breakpoint}
          />
        </div>

        <div data-cy="forgot-password-modal" className="forgot-password-modal">
          <ForgotPassword
            isOpen={showModal}
            toggleOpen={this.showModal}
            breakpoint={breakpoint}
          />
        </div>
        <div key="forgot-password" className="forgot-password">
          {auth_status.status !== "LOGIN_SUCCESS" &&
            auth_status.status !== "MFA_ERROR" && (
              <>
                <div
                  data-cy="forgot-your-password"
                  className="forgot-password-link"
                  onClick={this.showModal}
                >
                  Forgot your Password ?
                </div>
                {auth_status?.attemptCount >= 3 && (
                  <div
                    data-cy="trouble-logging-in"
                    className="trouble-logging-in"
                    onClick={this.showHelpModal}
                  >
                    Trouble Logging in ?
                  </div>
                )}
              </>
            )}
        </div>
        {alert && (
          <button
            className="labels21 alert-button"
            variant="primary"
            type="submit"
            onClick={this.showModal}
          >
            {alert?.message}
          </button>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      sampleEnterUsername,
      loginUserPhaseOne,
      loginUserPhaseTwo,
      mfaOptionRequest,
      requestLoginUsernameReset,
      loginReset,
      enterMfaTimeout1,
      enterMfaTimeout1Email,
      enterMfaTimeout1Phone,
      enterMfaTimeout2,
      resetMfaTimeoutCondition,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPageNew);
